import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ImageModule from "../../modules/image_module";
import ContentModule from "../../modules/content_module";
import "./Reviews.scss";
import BgImage from "../../common/ggfx-client/module/components/bgstyle";

const Reviews = ({Module, GQLPage}) => {

  let [isPlay, setPlay] = React.useState(false);

  return (
    <React.Fragment>
      <section className="reviews-section">
        <div className="review_img" style={{backgroundImage:`url(${Module?.background_image?.url})`}}>
       
          <Container>
            <Row>
              <Col>
                  <div className="review_details">
                      <div className="review_content"><ContentModule Content={Module?.review_content} /></div>
                      <div className="review_author">{Module?.author}</div>
                  </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

    </React.Fragment>
  );
};
export default Reviews;